<template>
  <!--
      	作者：qjy
      	时间：2020-11-28
      	描述：插件中心-ICP-ICP设置
      -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--文件上传设置-->
      <div class="common-form">ICP查询接口设置</div>
      <el-form-item label="默认接口">
        <div>
          <el-radio v-model="form.radio" label="aizhan" @change="getRadio">爱站</el-radio>
          <el-radio v-model="form.radio" label="chinaz" @change="getRadio">站长站</el-radio>
        </div>
      </el-form-item>
      <!--爱站接口-->
      <div v-if="form.radio === 'aizhan'">
        <el-form-item label="url前缀"><el-input v-model="form.api.aizhan.baseUrl" placeholder="https://apistore.aizhan.com/site/icpinfos/" class="max-w460"></el-input></el-form-item>
        <el-form-item label="私钥"><el-input v-model="form.api.aizhan.private_key" class="max-w460"></el-input></el-form-item>
      </div>
      <!--站长接口-->
      <div v-if="form.radio === 'chinaz'">
        <el-form-item label="私钥(非实时)"><el-input v-model="form.api.chinaz.private_key" class="max-w460"></el-input></el-form-item>
        <el-form-item label="私钥(实时接口)"><el-input v-model="form.api.chinaz.new.private_key" class="max-w460"></el-input></el-form-item>
      </div>

      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>
  </div>
</template>
<script>
  import IcpApi from '@/api/icp.js'
  export default {
    data() {
      return {
        form: {
          radio: 'aizhan',
          api: {
            aizhan: {
              // private_key: '0dde5246ac7d10fd56a5a5a1fcedab3a',
              baseUrl: 'https://apistore.aizhan.com/site/icpinfos/',
            },
            chinaz: {
              private_key: '',
              new: {
                private_key: ''
              }
            },
          }
        },
        loading: false
      };
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        let self = this;
        IcpApi.apiDetail({}, true)
          .then(data => {
            let vars = data.data.vars.values;
            self.form.radio = vars.default;
            self.form.api = vars.api;
          })
          .catch(error => {});
      },
      //提交表单
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        IcpApi.editIcpApi(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，上传设置成功',
              type: 'success'
            });
            // self.$router.push('/setting/Storage');
          })
          .catch(error => {
            self.loading = false;
          });
      },
      //监听单选按钮
      getRadio(val) {},
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/icp/icp/setting.vue